import * as PIXI from "pixi.js";
import Main from "../Main";
import TextureManager from "../managers/TextureManager";


const lbWidth = 200;
const lbHeight = 20

export default class LoadingPage extends PIXI.Container {
  private Main = Main.getInstance();
  private dim = this.Main.getDim();
  private loadingbar = new PIXI.Graphics()
  constructor() {
    super();
    this.addBg();
    this.addLogo();
    this.drawLoadingBarBg();
    this.addToStage();
  }

  addBg() {
    const bg = new PIXI.Graphics()
      .rect(0, 0, this.dim.width, this.dim.height)
      .fill(0x000000);
    this.addChild(bg);
  }

  addLogo() {
    const texture = TextureManager.getLogo();
    const logo = new PIXI.Sprite(texture);
    logo.anchor.set(.5);
    logo.width = 127;
    logo.height = 127;
    logo.x = this.dim.width / 2;
    logo.y = this.dim.height / 2;

    this.addChild(logo);
  }
  drawLoadingBarBg() {
    const bg = new PIXI.Graphics()
      .roundRect(-lbWidth / 2, -lbHeight / 2, lbWidth, lbHeight, lbHeight / 4)
      .fill(0x111111)
    bg.x = this.dim.width / 2;
    bg.y = this.dim.height / 2 + 100;
    this.addChild(bg);
  }
  drawLoadingBar(v: number) {
    const _width = lbWidth / 100 * v
    this.loadingbar.clear()
      .roundRect(-lbWidth / 2, -lbHeight / 2, _width, lbHeight, lbHeight / 4)
      .fill(0xeb5252);
    this.loadingbar.x = this.dim.width / 2;
    this.loadingbar.y = this.dim.height / 2 + 100;
    this.addChild(this.loadingbar)
  }
  remove() {
    this.parent.removeChild(this);
    this.destroy();
  }
  addToStage() {
    this.Main.stage.addChild(this);
  }
}